module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"add_compensation":"Add your compensation"},"ja":{"add_compensation":"年収を追加"}}')
  delete Component.options._Ctor
}
